module.exports = __webpack_public_path__ + "img/Hainan-speed.fbe2ecb2.png";